import DatePicker from 'components/date-picker/DatePicker';
import accountStyles from './account-option.style';
import { useEffect, useState } from 'react';
import moment from 'moment';
import userApi from 'apis/userApi';
import { InfoPaginate } from 'models/commonModel';
import Pagination from 'components/pagination/Pagination';
import LoadingIcon from 'components/loading/LoadingIcon';
import toast from 'react-hot-toast';
import classNames from 'classnames';
import { HistoryBetPayload } from 'models/fundTransferModel';
import Modal from 'components/modal/Modal';
import BetRecord from 'components/bet-record/BetRecord';
import { scrollToTopPage } from 'utils/function';
import styles from "./account-option.style";

interface StatusItem {
    description: string;
    disabled: boolean;
    escape: boolean;
    label: string;
    noSelectionOption: boolean;
    value: string;
}

const timeOptionBet = [
    {
        value: '0',
        label: 'Thời gian cược',
    },
    {
        value: '1',
        label: 'Thời gian trả thưởng',
    },
];

function FundBet() {
    const [startTime, setStartTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')} 00:00:00`));
    const [endTime, setEndTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')} 23:59:59`));

    const [statusList, setStatusList] = useState<StatusItem[]>([]);
    const [statusSelect, setStatusSelect] = useState('');

    const [timeSelect, setTimeSelect] = useState('0');

    const [gameList, setGameList] = useState<StatusItem[]>([]);
    const [gameValueSelect, setGameValueSelect] = useState('-1');
    const [infoPage, setInfoPage] = useState<InfoPaginate | null>(null);
    const [recordList, setRecordList] = useState<any[] | null>(null);

    const [betId, setBetId] = useState('');
    const [loading, setLoading] = useState(false);

    const [totalBetWin, setTotalBetWin] = useState<{ tbet: number; twin: number }>({ tbet: 0, twin: 0 });
    const [betRecordId, setBetRecordId] = useState<string | null>(null);

    useEffect(() => {
        const getStatusList = async () => {
            try {
                const { data } = await userApi.gameRecordInit({});
                if (!data.msg) {
                    //remove 5:huy nuôi số, 9:nổ hũ
                    const statusData: any[] = data.statuslist.filter((item: StatusItem) => ![5, 9].includes(Number(item.value)));
                    setStatusList(statusData);

                    //remove 300:txcb, 301:tren duoi, 303:cao rua v1, 22:livestream 2p, tai xiu, xoc dia, bau cua
                    const gameData = data.lotterylist.filter((item: StatusItem) => ![300, 301, 303, 22, 90, 91, 92, 93, 80, 60].includes(Number(item.value)));
                    setGameList(gameData);
                    if (statusData.length > 0) {
                        setStatusSelect(statusData[0].value);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        getStatusList();
    }, []);

    const handleChangePage = (typeSearch: 'btnSearch' | 'nextPage' | 'proPage') => {
        searchRecordBet(1, false, typeSearch);
        scrollToTopPage();
    };

    const searchRecordBet = async (page: 1, isResetPaginate: boolean, type: 'btnSearch' | 'nextPage' | 'proPage') => {
        if (isResetPaginate) {
            setInfoPage(null);
        }
        setLoading(true);
        let payload: HistoryBetPayload = {
            status: statusSelect,
            betid: betId,
            starttime: startTime ? moment(startTime).format('yyyy-MM-DD HH:mm:ss') : '',
            endtime: endTime ? moment(endTime).format('yyyy-MM-DD HH:mm:ss') : '',
            lotteryid: Number(gameValueSelect),
            pagesize: 10,
            type: timeSelect,
        };

        if (type === 'nextPage') {
            payload = {
                ...payload,
                curpage: infoPage?.curpage,
                num: page,
            };
        }
        try {
            const { data } = await userApi.gameRecordSearch(payload, type);
            if (!data.msg) {
                setRecordList(data.reslist);
                console.log(data.reslist);
                const { curpage, totalpage, totalrecord } = data;
                setInfoPage({ curpage, totalpage, totalrecord });

                setTotalBetWin({ tbet: data.tamount, twin: data.twin });
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancelBet = (recordId: string) => {};

    return (
        <>
            <div className={`${accountStyles.wrap}`}>
                <div className={accountStyles.mw800}>
                    <h6 className={accountStyles.title}>Lịch Sử Cược</h6>
                    <div className={accountStyles.flexbox}>
                        <div className={`${accountStyles.flex50} ${accountStyles.groupInput}`}>
                            <label htmlFor="">Thời Gian Từ</label>
                            <div className={accountStyles.wrapInput}>
                                <DatePicker showTime dateSelect={startTime} onSelectDate={(date) => setStartTime(date)} showIcon />
                            </div>
                        </div>
                        <div className={`${accountStyles.flex50} ${accountStyles.groupInput}`}>
                            <label htmlFor="">Đến</label>
                            <div className={accountStyles.wrapInput}>
                                <DatePicker showTime dateSelect={endTime} onSelectDate={(date) => setEndTime(date)} showIcon />
                            </div>
                        </div>

                        <div className={`${accountStyles.flex50} ${accountStyles.groupInput}`}>
                            <label htmlFor="">Trạng Thái</label>
                            <div className={accountStyles.wrapInput}>
                                <select className="input-common" value={statusSelect} onChange={(e) => setStatusSelect(e.target.value)}>
                                    {statusList.map((item) => (
                                        <option value={item.value} key={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className={`${accountStyles.groupInput} ${accountStyles.flex50}`}>
                            <label htmlFor="">Mã Số Cược</label>
                            <div className={accountStyles.wrapInput}>
                                <input value={betId} onChange={(e) => setBetId(e.target.value)} className={`input-common`} type="text" placeholder="Mã số cược" />
                            </div>
                        </div>
                        <div className={`${accountStyles.flex50} ${accountStyles.groupInput}`}>
                            <label htmlFor="">Loại Trò Chơi</label>
                            <div className={accountStyles.wrapInput}>
                                <select className="input-common" value={gameValueSelect} onChange={(e) => setGameValueSelect(e.target.value)}>
                                    {gameList.map((item) => (
                                        <option value={item.value} key={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className={`${accountStyles.flex50} ${accountStyles.groupInput}`}>
                            <label htmlFor="">Thời Gian</label>
                            <div className={accountStyles.wrapInput}>
                                <select className="input-common" value={timeSelect} onChange={(e) => setTimeSelect(e.target.value)}>
                                    {timeOptionBet.map((item) => (
                                        <option value={item.value} key={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.elmSubmit}`}>
                        <button type="submit" className={`btn-primary ${accountStyles.btnSubmit}`} onClick={() => searchRecordBet(1, true, 'btnSearch')}>
                            Tìm Kiếm
                        </button>
                    </div>
                </div>
                <div className="table-common">
                    {recordList ? (
                        <>
                            {recordList.length > 0 ? (
                                recordList.map((item) => (
                                    <div className="col-table" key={item.id}>
                                        <div className="col-header">
                                            <p>{item.loginname}</p>
                                            <span>Thời Gian: <strong>{moment(item.inserttime).format('DD/MM/yyyy HH:mm')}</strong></span>
                                        </div>
                                        <div className="row" key={item.id}>
                                            <div className="col">
                                                <p>Loại trò chơi:</p>
                                                <strong>{item.lotteryname}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Kiểu chơi:</p>
                                                <strong>{![60, 80, 90, 91, 92, 93, 300, 301].includes(item.lotteryid) ? item.methodname : '-'}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Lượt xổ:</p>
                                                <strong>{item.issue}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Cược:</p>
                                                <strong>{new Intl.NumberFormat().format(item.bonus)}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Trúng:</p>
                                                <strong className='text-success'>{new Intl.NumberFormat().format(item.bonus)}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Trạng thái:</p>
                                                <strong className={classNames({ 'text-success': item.status === 4 }, { 'text-error': [1, 3].includes(item.status) })}>{item.statusname}</strong>
                                            </div>
                                            {(item.lotteryid !== 401 && item.lotteryid !== 403 && item.lotteryid !== 404) && (
                                                <div className="col">
                                                    <p>Chi tiết:</p>
                                                    <span
                                                        className="btn-detail"
                                                        style={{ padding: '4px 0', width: '100%', display: 'block' }}
                                                        onClick={() => setBetRecordId(item.id)}
                                                    >
                                                        Xem
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="no-data">
                                    <img src={require('assets/images/icons/no-data.png')} alt="" />
                                    <p>Không có dữ liệu</p>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="no-data"></div>
                    )}
                </div>
                {infoPage && infoPage.totalpage > 1 && (
                    <div className="pagination-common">
                        <div className="total">
                            {totalBetWin.tbet > 0 && (
                                <>
                                    <p>
                                        Cược: <span className="text-black">{new Intl.NumberFormat().format(totalBetWin.tbet)}</span>
                                    </p>
                                    <p className="line">|</p>
                                    <p>
                                        Thắng: <span className="text-success">{new Intl.NumberFormat().format(totalBetWin.twin)}</span>
                                    </p>
                                </>
                            )}
                        </div>
                        <Pagination infoPage={infoPage} onChangePage={(page) => handleChangePage(page as 'btnSearch' | 'nextPage' | 'proPage')} showTotal />
                    </div>
                )}
            </div>
            <Modal isShow={Boolean(betRecordId)} onClose={() => setBetRecordId(null)} closeClickBackdrop width="60%" maxWidth="900px">
                <BetRecord onClose={() => setBetRecordId(null)} betRecordId={betRecordId} onCancelBet={handleCancelBet} />
            </Modal>
            {loading && <LoadingIcon />}
        </>
    );
}

export default FundBet;
